import { MENTION_KEY } from '@techchange/pm-specs';
import { Plugin, PluginKey } from 'prosemirror-state';

import MentionView from '../nodeView';

export const mentionViewPluginKey = new PluginKey('mentionViewPlugin');

/**
 * Plugin that manages the state for triggering an at-mention.
 *
 * @param {object} mentionUsers  	The users that are available to at-mention.
 * @param {string} scope         	The scope of the at-mention.
 * @param {string} scopeId       	The scope ID of the at-mention.
 * @param {function} onMentionClick	The click handler to trigger the user modal for at mentions.
 *
 * @returns {Object} Prosemirror Plugin object.
 */
const mentionViewPlugin = (mentionUsers, scope, scopeId, onMentionClick) =>

	new Plugin({

		key: mentionViewPluginKey,

		state: {

			// Initializes the plugin state
			init() {

				return {

					/**
					 * The mention PM node.
					 */
					mentionNode: null,

					/**
					 * The mention DOM element.
					 */
					mentionDOM: null,

				};

			},

			// Updates the plugin state given incoming editor transaction
			apply(tr, pluginState) {

				const mentionNode = tr.getMeta('mentionNode');
				const mentionDOM = tr.getMeta('mentionDOM');

				return {
					mentionNode: (mentionNode === undefined) ? pluginState.mentionNode : mentionNode,
					mentionDOM: (mentionDOM === undefined) ? pluginState.mentionDOM : mentionDOM,
				};

			}

		},

		props: {

			nodeViews: {

				[MENTION_KEY]: (node, view) =>
					new MentionView(node, view, mentionUsers, scope, scopeId, onMentionClick),

			},

		},

	});

export default mentionViewPlugin;
